<ion-header>
    <ion-toolbar></ion-toolbar>
</ion-header>

<ion-content>
    <div class="ion-text-center ion-padding-start ion-padding-end ion-padding-bottom">

        <h3 id="page-title">{{ 'PERMISSION_REQUEST_EXACT_ALARM_TITLE' | translate }}</h3>
        <h6 id="page-title" [innerHTML]="'PERMISSION_REQUEST_EXACT_ALARM_TEXT' | translate"></h6>

        <div class="button-container ion-text-center">
            <ion-button class="emphasized-button" (click)="onEnableClick()" [innerHTML]="'PERMISSION_REQUEST_EXACT_ALARM_BUTTON' | translate"></ion-button>
        </div>
    </div>
</ion-content>
